import api from './api';

const subscriptionService = {
  getAll: async (params = {}) => {
    const response = await api.get('/subscriptions', { params });
    return response.data;
  },
  getStats: async () => {
    const response = await api.get('/subscriptions/stats');
    return response.data;
  },
  getOverview: async () => {
    const response = await api.get('/subscriptions/overview');
    return response.data;
  },
  getReport: async (type, params = {}) => {
    const response = await api.get(`/subscriptions/reports/${type}`, { params });
    return response.data;
  },
  getExpirations: async (params = {}) => {
    const response = await api.get('/subscriptions/expirations', { params });
    return response.data;
  },
  getRenewalsBoard: async (params = {}) => {
    const response = await api.get('/subscriptions/renewals-board', { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/subscriptions/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/subscriptions', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/subscriptions/${id}`, data);
    return response.data;
  },
  renew: async (id, data = {}) => {
    const response = await api.post(`/subscriptions/${id}/renew`, data);
    return response.data;
  },
  approveRenewal: async (id, data = {}) => {
    const response = await api.post(`/subscriptions/${id}/approve-renewal`, data);
    return response.data;
  },
  previewReminder: async (id, data = {}) => {
    const response = await api.post(`/subscriptions/${id}/reminders/preview`, data);
    return response.data;
  },
  sendTestReminder: async (id, data = {}) => {
    const response = await api.post(`/subscriptions/${id}/reminders/test`, data);
    return response.data;
  },
  sendReminderNow: async (id, data = {}) => {
    const response = await api.post(`/subscriptions/${id}/reminders/send`, data);
    return response.data;
  },
  markAction: async (id, data = {}) => {
    const response = await api.post(`/subscriptions/${id}/action`, data);
    return response.data;
  },
  getReminderHistory: async (params = {}) => {
    const response = await api.get('/subscriptions/reminder-history', { params });
    return response.data;
  },
  getAuditLog: async (id) => {
    const response = await api.get(`/subscriptions/${id}/audit`);
    return response.data;
  },
  getCategories: async () => {
    const response = await api.get('/subscriptions/categories');
    return response.data;
  },
  getModuleSettings: async () => {
    const response = await api.get('/subscriptions/settings');
    return response.data;
  },
  saveModuleSettings: async (data) => {
    const response = await api.put('/subscriptions/settings', data);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/subscriptions/${id}`);
    return response.data;
  },
};

export default subscriptionService;
